import React from 'react';
import {
  FaTimes,
  FaTrashAlt,
  FaMinus,
  FaPlus,
  FaArrowRight,
} from 'react-icons/fa';
import { useThemeColors } from '../hooks/useThemeColors';
import {
  addToCart,
  getAvailableCartItems,
  removeFromCart,
} from '../redux/addCart/cartSlice';
import { useDispatch, useSelector } from 'react-redux';
import EmptyCart from './common/EmptyCart';
import { getImagePath } from '../constants/defaultValues';
import { useNavigate } from 'react-router-dom';

const CartForResponsive = ({ isOpen, onClose, darkMode }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { cardBg, textColor, borderColor, headerBg, isDark, contentBg } =
    useThemeColors(darkMode);

  const cartItems = useSelector(getAvailableCartItems);
  const finalTotal = cartItems.reduce(
    (sum, item) => sum + item.shopPrice * item.quantity,
    0
  );

  const handleAction = () => {
    navigate('/cartItemsDetails');
    onClose();
  };

  return (
    <div
      className="order-tracker-container d-flex flex-column"
      style={{
        backgroundColor: contentBg,
        zIndex: 1149,
        color: textColor,
        borderLeft: `1px solid ${borderColor}`,
        position: 'fixed',
        right: 0,
        top: '65px',
        height: 'calc(100vh - 65px)',
        width: '400px',
        maxWidth: '100%',
        boxShadow: '-5px 0 15px rgba(0,0,0,0.1)',
        transition: 'transform 0.3s ease',
        transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
      }}
    >
      <div
        className="order-tracker-header d-flex justify-content-between align-items-center p-3 border-bottom"
        style={{ backgroundColor: headerBg, borderColor: borderColor }}
      >
        <h5 className="mb-0 fw-bold">Your Basket</h5>
        <button
          className="btn p-2 border-0 rounded-circle d-flex align-items-center justify-content-center"
          onClick={onClose}
          style={{
            backgroundColor: isDark
              ? 'rgba(255,255,255,0.1)'
              : 'rgba(0,0,0,0.05)',
          }}
        >
          <FaTimes size={18} className="text-danger" />
        </button>
      </div>

      {/* 2. Scrollable Body Section */}
      <div
        className="flex-grow-1 p-3" // flex-grow-1 ensures ye baqi bachi hui jagah le
        style={{ overflowY: 'auto' }} // Sirf ye hissa scroll hoga
      >
        {cartItems.length === 0 ? (
          <EmptyCart darkMode={isDark} />
        ) : (
          cartItems.map((item) => (
            <div
              key={item.id}
              className="card mb-3 rounded border-0 shadow-sm"
              style={{ backgroundColor: cardBg }}
            >
              <div className="card-body p-2 d-flex align-items-center gap-3">
                {item.image?.fileToken ? (
                  <img
                    src={`${getImagePath}${item.image.fileToken}`}
                    alt={item.name || 'product'}
                    className="rounded-3"
                    style={{
                      width: '60px',
                      height: '60px',
                      objectFit: 'cover',
                    }}
                  />
                ) : (
                  <div
                    className="rounded-3 bg-light d-flex align-items-center justify-content-center"
                    style={{
                      width: '60px',
                      height: '60px',
                      fontSize: '10px',
                      color: '#ccc',
                    }}
                  >
                    No Image
                  </div>
                )}
                <div className="flex-grow-1 overflow-hidden">
                  <div className="d-flex justify-content-between">
                    <span
                      className="fw-bold small text-truncate pe-2"
                      style={{ color: textColor }}
                    >
                      {item.name}
                    </span>
                    <span className="text-danger fw-bold small">
                      Rs {(item.shopPrice * item.quantity).toLocaleString()}
                    </span>
                  </div>

                  <div className="d-flex align-items-center justify-content-between mt-2">
                    <div
                      className="d-flex align-items-center rounded border"
                      style={{
                        backgroundColor: isDark
                          ? 'rgba(255,255,255,0.05)'
                          : '#f8f9fa',
                        borderColor: borderColor,
                      }}
                    >
                      <button
                        className="btn btn-sm p-1 text-danger"
                        onClick={() =>
                          dispatch(removeFromCart({ itemId: item.id }))
                        }
                      >
                        {item.quantity === 1 ? (
                          <FaTrashAlt size={12} />
                        ) : (
                          <FaMinus size={12} />
                        )}
                      </button>
                      <span
                        className="small fw-bold px-3"
                        style={{ color: textColor }}
                      >
                        {item.quantity}
                      </span>
                      <button
                        className="btn btn-sm p-1 text-success"
                        onClick={() =>
                          dispatch(addToCart({ ...item, quantity: 1 }))
                        }
                      >
                        <FaPlus size={12} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* 3. Footer Section (Fixed at Bottom) */}
      <div
        className="p-3 border-top"
        style={{ backgroundColor: headerBg, borderColor: borderColor }}
      >
        <button
          className="btn btn-danger w-100 rounded py-3 shadow-sm fw-bold d-flex justify-content-between align-items-center px-4"
          onClick={handleAction}
          disabled={cartItems.length === 0} // Agar cart empty ho to disable kar dein
          style={{ transition: '0.3s' }}
        >
          <span>Checkout</span>
          <div className="d-flex align-items-center gap-2">
            <span>Rs {finalTotal.toLocaleString()}</span>
            <FaArrowRight />
          </div>
        </button>
      </div>
    </div>
  );
};

export default CartForResponsive;
